import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useProductPageLayoutQuery = createQueryHook(
  ShopRendererDraftApiClient.getProductPageTemplateLayout,
  {
    queryKey: ['productPageLayout'],
  },
)
